import React from 'react'

const BAR_COUNT = 12
// Same geometry as the rendered dashboard chart (BarChartClassroom with
// height={140}, showEmotions, emotionSize={20}) so the crossfade never shifts
// layout: 20px count row + 140px track, 9px gap, 15px label line, 5px gap,
// 20px emoji.
const TRACK_HEIGHT = 140
const COUNT_ROW = 20
const LABEL_BLOCK = 15
// One height per bar (px), shaped like a typical mood distribution so the
// placeholder does not read as a repeating pattern. Max is 9/10 of the track,
// like the real chart's tallest bar.
const BAR_HEIGHTS = [88, 112, 126, 126, 78, 50, 40, 70, 100, 118, 46, 94]

const BarChartClassroomSkeleton = () => {
    return (
        <div style={{ width: '100%', position: 'relative' }} aria-hidden="true">
            <div
                style={{
                    height: TRACK_HEIGHT,
                    position: 'relative',
                    borderBottom: '1px solid #ecebf8',
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'flex-end',
                    }}
                >
                    {Array.from({ length: BAR_COUNT }).map((_, idx) => (
                        <div
                            key={idx}
                            style={{
                                flex: 1,
                                minWidth: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                            }}
                        >
                            <div style={{ height: COUNT_ROW }} />
                            <div
                                className="animate-pulse"
                                style={{
                                    width: '85%',
                                    height: BAR_HEIGHTS[idx % BAR_HEIGHTS.length],
                                    borderTopLeftRadius: 6,
                                    borderTopRightRadius: 6,
                                    background: '#ecebf8',
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
            <div style={{ marginTop: 9, display: 'flex', flexDirection: 'row' }}>
                {Array.from({ length: BAR_COUNT }).map((_, idx) => (
                    <div
                        key={idx}
                        style={{
                            flex: 1,
                            minWidth: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <div style={{ height: LABEL_BLOCK, display: 'flex', alignItems: 'center' }}>
                            <div className="animate-pulse" style={{ width: 34, height: 10, borderRadius: 5, background: '#ecebf8' }} />
                        </div>
                        <div
                            className="animate-pulse"
                            style={{
                                width: 20,
                                height: 20,
                                borderRadius: 10,
                                background: '#ecebf8',
                                marginTop: 5,
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default BarChartClassroomSkeleton
